export default __webpack_public_path__ + "static/media/hero10.a17931bd.jpg";